module.exports = __webpack_public_path__ + "static/img/publicAddress.08e43a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/publicAddress.png
// module id = Z3Rd
// module chunks = 1